import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'

import { AuthenticationContext } from '../../../contexts/authentication'

import { apolloClient } from '../../../index'

class Logout extends React.Component {

    static contextType = AuthenticationContext

    componentDidMount = () => {
        apolloClient.resetStore()
        this.context.setAuthenticationStatus()
        this.props.history.push('/')
    }

    render() {
        return ('logging out...')
    }

    
}

export default Logout;